/* eslint-disable */
/* eslint-disable no-restricted-globals, no-undef */
import React, { useEffect, useState } from 'react';
import { 
  Box, 
  Flex, 
  Heading, 
  Text, 
  Spinner, 
  Stat, 
  StatLabel, 
  StatNumber, 
  StatHelpText, 
  StatArrow, 
  SimpleGrid, 
  Button,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Select,
  useToast,
  Badge,
  Stack,
  useColorModeValue,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  Grid,
  Icon
} from "@chakra-ui/react";
import TeacherNavTop from "./TeacherNavTop"; 
import { useDispatch, useSelector } from "react-redux";
import { getTeacherCourses } from "../../Redux/TeacherReducer/action";
import Card from "../../Pages/LandingPageComponents/Card";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FaPlus, FaVideo, FaGraduationCap, FaAward, FaCalendarAlt, FaEllipsisV, FaChartBar, FaUsers } from "react-icons/fa";
import { Bar, Doughnut } from "react-chartjs-2";
import "chart.js/auto";
import { useModalToast } from "../../context/GlobalModalToast";

const TeacherDashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const teacherStore = useSelector((store) => store.TeacherReducer);
  const courses = teacherStore?.data || [];
  const isLoading = teacherStore?.isLoading;
  const userStore = useSelector((store) => store.UserReducer);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [sessions, setSessions] = useState([]);
  const [sessionForm, setSessionForm] = useState({
    title: "",
    description: "",
    meetingLink: "",
    scheduledAt: "",
    duration: 60,
    targetSector: "Global"
  });
  const [editSessionId, setEditSessionId] = useState(null);
  const { toast, confirm } = useModalToast();

  const [engagementData, setEngagementData] = useState(null);
  const [engagementPeriod, setEngagementPeriod] = useState("month");
  
  const [lnaTelemetry, setLnaTelemetry] = useState(null);

  const bgMain = useColorModeValue("gray.50", "gray.900");
  const cardBg = useColorModeValue("white", "rgba(15, 23, 42, 0.7)");
  const cardBorder = useColorModeValue("gray.100", "rgba(255, 255, 255, 0.08)");
  const headerWidgetBg = useColorModeValue("rgba(255, 255, 255, 0.45)", "rgba(15, 23, 42, 0.7)");
  const headerWidgetBorder = useColorModeValue("rgba(255, 255, 255, 0.5)", "rgba(255, 255, 255, 0.08)");
  const statCardBg = useColorModeValue("rgba(255, 255, 255, 0.45)", "rgba(15, 23, 42, 0.65)");
  const statCardBorder = useColorModeValue("rgba(255, 255, 255, 0.5)", "rgba(255, 255, 255, 0.08)");
  const headingColor = useColorModeValue("gray.800", "white");
  const textColor = useColorModeValue("gray.500", "gray.300");
  const selectBg = useColorModeValue("gray.50", "rgba(15, 23, 42, 0.5)");
  const gridLineColor = useColorModeValue("rgba(0,0,0,0.05)", "rgba(255,255,255,0.05)");
  const lockedBg = useColorModeValue("gray.50", "rgba(255,255,255,0.04)");
  const lockedBorder = useColorModeValue("gray.300", "rgba(255,255,255,0.15)");
  const progressBg = useColorModeValue("blackAlpha.100", "whiteAlpha.100");

  useEffect(() => {
    dispatch(getTeacherCourses());
    fetchTeacherSessions();
  }, [dispatch]);

  useEffect(() => {
    const fetchEngagement = async () => {
      try {
        const token = JSON.parse(localStorage.getItem('user'))?.token || "";
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/reports/engagement?period=${engagementPeriod}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setEngagementData(res.data);
      } catch (err) {
        console.error("Failed to load engagement data", err);
      }
    };

    const fetchLnaTelemetry = async () => {
      try {
        const token = JSON.parse(localStorage.getItem('user'))?.token || "";
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/lna/telemetry`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        // Format for ChartJS
        if (res.data && res.data.length > 0) {
          const vibrantColors = ['#7c3aed', '#0ea5e9', '#10b981', '#f59e0b', '#c026d3', '#ef4444'];
          setLnaTelemetry({
            labels: res.data.map(d => d.category),
            datasets: [{
              label: 'Average Difficulty Score',
              data: res.data.map(d => d.averageDifficulty),
              backgroundColor: res.data.map((_, i) => vibrantColors[i % vibrantColors.length]),
              borderColor: cardBg,
              borderWidth: 3,
              hoverOffset: 6
            }]
          });
        }
      } catch (err) {
        console.error("Failed to fetch LNA telemetry", err);
      }
    };

    fetchEngagement();
    fetchLnaTelemetry();
  }, [engagementPeriod]);

  const fetchTeacherSessions = async () => {
    try {
      const token = JSON.parse(localStorage.getItem("user"))?.token || "";
      if (!token) return;
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/livesessions`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      const loggedUser = JSON.parse(localStorage.getItem("user")) || {};
      const loggedUserId = loggedUser.userId || userStore.userId;
      const loggedName = loggedUser.name || userStore.name;
      
      const teacherSessions = res.data.filter(s => 
        !s.hostId || 
        String(s.hostId) === String(loggedUserId) || 
        s.hostName === loggedName
      );
      setSessions(teacherSessions);
    } catch (err) {
      console.error("Failed to fetch teacher live sessions:", err);
    }
  };

  const handleSessionChange = (e) => {
    const { name, value } = e.target;
    setSessionForm(prev => ({ ...prev, [name]: value }));
  };

  const handleCreateSession = async () => {
    try {
      const token = JSON.parse(localStorage.getItem("user"))?.token || "";
      if (!token) return;
      
      if (editSessionId) {
        await axios.patch(`${process.env.REACT_APP_API_URL}/api/livesessions/${editSessionId}`, sessionForm, {
          headers: { Authorization: `Bearer ${token}` }
        });
        toast({ title: "Live session updated successfully!", status: "success", duration: 3000 });
      } else {
        await axios.post(`${process.env.REACT_APP_API_URL}/api/livesessions`, sessionForm, {
          headers: { Authorization: `Bearer ${token}` }
        });
        toast({ title: "Live session scheduled successfully!", status: "success", duration: 3000 });
      }
      
      handleCloseModal();
      fetchTeacherSessions();
    } catch (err) {
      toast({ title: err.response?.data?.message || "Failed to schedule live session", status: "error", duration: 3000 });
    }
  };

  const handleEditSession = (session) => {
    // Convert to local datetime-local format string
    const dateObj = new Date(session.scheduledAt);
    const offset = dateObj.getTimezoneOffset() * 60000;
    const localISOTime = (new Date(dateObj - offset)).toISOString().slice(0,16);

    setSessionForm({
      title: session.title,
      description: session.description,
      meetingLink: session.meetingLink,
      scheduledAt: localISOTime,
      duration: session.duration,
      targetSector: session.targetSector || "Global"
    });
    setEditSessionId(session._id);
    onOpen();
  };

  const handleStartImmediately = async (sessionId) => {
    try {
      const token = JSON.parse(localStorage.getItem("user"))?.token || "";
      if (!token) return;
      const now = new Date();
      now.setMinutes(now.getMinutes() - 2); // 2 minutes ago to guarantee it's unlocked immediately
      
      await axios.patch(`${process.env.REACT_APP_API_URL}/api/livesessions/${sessionId}`, { scheduledAt: now.toISOString() }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast({ title: "Session unlocked successfully!", status: "success", duration: 3000 });
      fetchTeacherSessions();
    } catch (err) {
      toast({ title: "Failed to unlock session", status: "error", duration: 3000 });
    }
  };

  const handleCloseModal = () => {
    onClose();
    setEditSessionId(null);
    setSessionForm({
      title: "",
      description: "",
      meetingLink: "",
      scheduledAt: "",
      duration: 60,
      targetSector: "Global"
    });
  };

  const handleDeleteSession = async (sessionId) => {
    { const _c = await confirm({ title: "Confirm", description: "Are you sure you want to cancel this live session?", status: "warning" }); if (!_c) return; }
    try {
      const token = JSON.parse(localStorage.getItem("user"))?.token || "";
      if (!token) return;
      await axios.delete(`${process.env.REACT_APP_API_URL}/api/livesessions/${sessionId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast({ title: "Live session cancelled", status: "info", duration: 3000 });
      fetchTeacherSessions();
    } catch (err) {
      toast({ title: err.response?.data?.message || "Failed to cancel live session", status: "error", duration: 3000 });
    }
  };

  const totalEnrollments = courses?.reduce((acc, curr) => acc + (curr.enrolledUsers?.length || 0), 0) || 0;

  return (
    <Box mt={{ base: -4, md: -8 }} mx={{ base: -4, md: -8 }} w="auto" bg={bgMain} minH="100vh" pb={10} px={{ base: 4, md: 8, lg: 10 }}>
      <TeacherNavTop />
      
      <Box pt={2}>
        
        {/* Top Header Row */}
        <Flex 
          className="glass-card"
          p={4}
          borderRadius="3xl"
          bg={headerWidgetBg}
          border="1px solid"
          borderColor={headerWidgetBorder}
          boxShadow="var(--shadow-premium)"
          backdropFilter="blur(20px)"
          justify="space-between"
          align="center"
          flexWrap="wrap"
          gap={6}
          mb={8}
        >
          <Box>
            <Badge colorScheme="blue" variant="subtle" px={3} py={1} borderRadius="full" fontSize="10px" fontWeight="800" mb={3} letterSpacing="0.5px">
              🎓 Faculty Center
            </Badge>
            <Heading size="lg" fontWeight="850" color={headingColor} letterSpacing="-1px">
              Welcome back, {userStore.name?.split(' ')[0]}
            </Heading>
            <Text fontSize="xs" color={textColor} mt={1}>
              Manage your curricula, webinar rooms, and employee evaluation compliance
            </Text>
          </Box>
          <Flex gap={4} wrap="wrap">
            <Button 
              leftIcon={<FaChartBar />}
              variant="outline"
              borderColor={useColorModeValue("rgba(0,0,0,0.06)", "rgba(255,255,255,0.08)")}
              bg={useColorModeValue("white", "rgba(15, 23, 42, 0.5)")}
              color={headingColor}
              borderRadius="full"
              fontSize="xs"
              fontWeight="800"
              className="hover-lift"
              h="46px"
              px={6}
              boxShadow="var(--shadow-sm)"
              onClick={() => navigate("/manager/dashboard")}
              _hover={{ bg: useColorModeValue("gray.50", "rgba(255, 255, 255, 0.05)") }}
            >
              Team Progress
            </Button>
            <Button 
              leftIcon={<FaVideo />}
              variant="outline"
              borderColor={useColorModeValue("rgba(0,0,0,0.06)", "rgba(255,255,255,0.08)")}
              bg={useColorModeValue("white", "rgba(15, 23, 42, 0.5)")}
              color={headingColor}
              borderRadius="full"
              fontSize="xs"
              fontWeight="800"
              className="hover-lift"
              h="46px"
              px={6}
              boxShadow="var(--shadow-sm)"
              onClick={onOpen}
              _hover={{ bg: useColorModeValue("gray.50", "rgba(255, 255, 255, 0.05)") }}
            >
              Schedule Live Training
            </Button>
            <Button 
              leftIcon={<FaPlus />}
              bgGradient="linear(to-r, #942F67, #A9A4C9)"
              color="white" 
              borderRadius="full"
              fontSize="xs"
              fontWeight="800"
              h="46px"
              px={6}
              boxShadow="0 4px 15px rgba(148,47,103,0.15)"
              onClick={() => navigate("/Teacher/add")}
              _hover={{ bgGradient: "linear(to-r, #7a2554, #86947A)", transform: "translateY(-2px)" }}
              _active={{ bgGradient: "linear(to-r, #7a2554, #86947A)" }}
              transition="all 0.2s"
            >
              Create New Course
            </Button>
          </Flex>
        </Flex>

        {/* ── Metric Cards Row ── */}
        <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)", xl: "repeat(4, 1fr)" }} gap={4} mb={4}>
          <Box bg="#0ea5e9" borderRadius="2xl" p="14px 16px" display="flex" flexDirection="column" gap={1}>
            <Flex fontSize="11px" fontWeight="700" textTransform="uppercase" letterSpacing="0.5px" color="whiteAlpha.800" align="center" gap={2}>
              <Icon as={FaGraduationCap} boxSize={4} /> Total courses
            </Flex>
            <Text fontSize="28px" fontWeight="800" color="white" lineHeight="1.1">
              {isLoading ? <Spinner size="sm" /> : courses?.length || 0}
            </Text>
            <Text fontSize="11px" color="whiteAlpha.600" fontWeight="600">Active Modules</Text>
          </Box>

          <Box bg="#7c3aed" borderRadius="2xl" p="14px 16px" display="flex" flexDirection="column" gap={1}>
            <Flex fontSize="11px" fontWeight="700" textTransform="uppercase" letterSpacing="0.5px" color="whiteAlpha.800" align="center" gap={2}>
              <Icon as={FaUsers} boxSize={4} /> Total Enrollments
            </Flex>
            <Text fontSize="28px" fontWeight="800" color="white" lineHeight="1.1">
              {isLoading ? <Spinner size="sm" /> : totalEnrollments}
            </Text>
            <Text fontSize="11px" color="whiteAlpha.600" fontWeight="600">Employees Certified</Text>
          </Box>

          <Box bg="#f59e0b" borderRadius="2xl" p="14px 16px" display="flex" flexDirection="column" gap={1}>
            <Flex fontSize="11px" fontWeight="700" textTransform="uppercase" letterSpacing="0.5px" color="whiteAlpha.800" align="center" gap={2}>
              <Icon as={FaAward} boxSize={4} /> Expert Rating
            </Flex>
            <Text fontSize="28px" fontWeight="800" color="white" lineHeight="1.1">4.8</Text>
            <Text fontSize="11px" color="whiteAlpha.600" fontWeight="600">Based on user evaluation</Text>
          </Box>

          <Box bg="#10b981" borderRadius="2xl" p="14px 16px" display="flex" flexDirection="column" gap={1}>
            <Flex fontSize="11px" fontWeight="700" textTransform="uppercase" letterSpacing="0.5px" color="whiteAlpha.800" align="center" gap={2}>
              <Icon as={FaVideo} boxSize={4} /> Live Sessions
            </Flex>
            <Text fontSize="28px" fontWeight="800" color="white" lineHeight="1.1">{sessions?.length || 0}</Text>
            <Text fontSize="11px" color="whiteAlpha.600" fontWeight="600">Active Broadcasts</Text>
          </Box>
        </Grid>

        <Grid templateColumns={{ base: "1fr", lg: "1.35fr 1fr" }} gap={4} mb={6}>
          {/* Engagement Ratio Graph */}
          <Flex 
            bg={cardBg} 
            p={4} 
            borderRadius="2xl" 
            boxShadow="sm" 
            border="1px solid" 
            borderColor={cardBorder}
            direction="column"
          >
            <Flex justify="space-between" align="center" mb={4}>
              <Text fontSize="lg" fontWeight="800" color={headingColor}>
                📈 Employee Engagement Ratio
              </Text>
              <Select 
                w="150px" 
                size="sm" 
                borderRadius="xl" 
                bg={selectBg} 
                color={headingColor}
                value={engagementPeriod}
                onChange={(e) => setEngagementPeriod(e.target.value)}
              >
                <option value="day">This Day</option>
                <option value="week">This Week</option>
                <option value="month">This Month</option>
                <option value="year">This Year</option>
              </Select>
            </Flex>
            
            <Box h="220px" w="full">
              {engagementData ? (
                <Bar 
                  data={engagementData} 
                  options={{ 
                    maintainAspectRatio: false,
                    scales: {
                      y: {
                        beginAtZero: true,
                        grid: { color: gridLineColor }
                      },
                      x: {
                        grid: { display: false }
                      }
                    }
                  }} 
                />
              ) : (
                <Flex h="100%" justify="center" align="center"><Spinner color="purple.500" /></Flex>
              )}
            </Box>
          </Flex>

          {/* LNA Telemetry Graph */}
          {lnaTelemetry && (
            <Flex 
              bg={cardBg} 
              p={4} 
              borderRadius="2xl" 
              boxShadow="sm" 
              border="1px solid" 
              borderColor={cardBorder}
              direction="column"
            >
              <Flex justify="space-between" align="center" mb={4}>
                <Box>
                  <Text fontSize="lg" fontWeight="800" color={headingColor}>
                    🧠 Learning Needs Analysis (LNA)
                  </Text>
                  <Text fontSize="xs" color={textColor} fontWeight="600">
                    Aggregated Course Difficulty Scores
                  </Text>
                </Box>
              </Flex>
              
              <Flex align="center" gap={6} flex={1}>
                <Box position="relative" w="155px" h="155px" flexShrink={0}>
                  <Doughnut 
                    data={lnaTelemetry} 
                    options={{ 
                      responsive: true, 
                      maintainAspectRatio: false,
                      cutout: "68%",
                      plugins: { legend: { display: false } }
                    }} 
                    plugins={[{
                      id: "centerText",
                      beforeDraw(chart) {
                        const { width, height, ctx } = chart;
                        ctx.restore();
                        const datasets = chart.config.data.datasets;
                        if (!datasets || !datasets[0] || !datasets[0].data || datasets[0].data.length === 0) return;
                        const dataArray = datasets[0].data;
                        const sum = dataArray.reduce((a, b) => Number(a) + Number(b), 0);
                        const avg = Math.round(sum / dataArray.length);
                        
                        ctx.font = "800 22px Inter, system-ui, sans-serif";
                        ctx.textBaseline = "middle";
                        ctx.fillStyle = headingColor === "white" ? "#fff" : "#1a202c";
                        const textX = Math.round((width - ctx.measureText(avg).width) / 2);
                        ctx.fillText(avg, textX, height / 2 - 8);
                        
                        ctx.font = "600 10px Inter, system-ui, sans-serif";
                        ctx.fillStyle = textColor === "gray.300" ? "#a0aec0" : "#718096";
                        const sub = "avg score";
                        const subX = Math.round((width - ctx.measureText(sub).width) / 2);
                        ctx.fillText(sub, subX, height / 2 + 12);
                        ctx.save();
                      }
                    }]}
                  />
                </Box>
                <Flex direction="column" gap={3} flex={1}>
                  {lnaTelemetry.labels.map((label, idx) => {
                    const score = lnaTelemetry.datasets[0].data[idx];
                    const color = lnaTelemetry.datasets[0].backgroundColor[idx];
                    return (
                      <Flex key={label} align="center" gap={3}>
                        <Box w="10px" h="10px" borderRadius="sm" bg={color} flexShrink={0} />
                        <Text fontSize="xs" color={textColor} flex={1} isTruncated>{label}</Text>
                        <Box flex={2} bg={progressBg} borderRadius="md" h="5px" overflow="hidden">
                          <Box w={`${score}%`} h="100%" bg={color} borderRadius="md" />
                        </Box>
                        <Text fontSize="11px" color={textColor} minW="26px" textAlign="right">{score}</Text>
                      </Flex>
                    );
                  })}
                </Flex>
              </Flex>
            </Flex>
          )}
        </Grid>

        {/* Modules Created Widget */}
        <Box mb={10}>
          <Heading size="sm" mb={4} fontWeight="850" color={headingColor} letterSpacing="-0.3px">
            Internal Courses Created
          </Heading>
          {isLoading ? (
            <Flex justify="center" p={10}><Spinner color="blue.500" thickness="3px" /></Flex>
          ) : (
            <SimpleGrid columns={{ base: 1, md: 2, lg: 3, xl: 4 }} spacing={6}>
              {courses?.length > 0 ? (
                courses.map((course) => (
                  <Card key={course._id} {...course} />
                ))
              ) : (
                <Text color={textColor} fontSize="xs" fontStyle="italic">No courses created yet. Start by adding a new one.</Text>
              )}
            </SimpleGrid>
          )}
        </Box>

        {/* Scheduled Training Webinars Widget */}
        <Box mb={10}>
          <Heading size="sm" mb={4} fontWeight="850" color={headingColor} letterSpacing="-0.3px">
            🎙️ Scheduled Live Training & Webinars
          </Heading>
          {sessions.length > 0 ? (
            <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
              {sessions.map((session) => {
                const now = Date.now();
                const startMs = new Date(session.scheduledAt).getTime();
                const unlockAt = startMs - 60 * 1000; // 1 min BEFORE start
                
                const scheduledDateObj = new Date(session.scheduledAt);
                scheduledDateObj.setHours(23, 59, 59, 999);
                const endOfDay = scheduledDateObj.getTime();
                
                const isUnlocked = now >= unlockAt && now <= endOfDay;
                const isExpired = now > endOfDay;
                
                const diffMs = Math.max(0, unlockAt - now);
                const totalSec = Math.floor(diffMs / 1000);
                const h = Math.floor(totalSec / 3600);
                const m = Math.floor((totalSec % 3600) / 60);
                const s = totalSec % 60;
                const countdown = h > 0 ? `${h}h ${m}m ${s}s` : m > 0 ? `${m}m ${s}s` : `${s}s`;

                return (
                  <Box
                    key={session._id}
                    className="glass-card hover-lift"
                    p={6}
                    borderRadius="3xl"
                    bg={statCardBg}
                    border="1px solid"
                    borderColor={statCardBorder}
                    boxShadow="var(--shadow-premium)"
                    opacity={isUnlocked ? 1 : 0.9}
                  >
                    <Flex justify="space-between" align="center" mb={3}>
                      <Badge colorScheme="blue" variant="subtle" borderRadius="full" px={2.5} fontSize="9px" fontWeight="800">
                        {session.targetSector} Sector
                      </Badge>
                      <Text fontSize="10px" fontWeight="700" color={textColor}>{session.duration} mins</Text>
                    </Flex>
                    <Heading size="xs" fontWeight="850" color={headingColor} mb={2} lineHeight="1.3">{session.title}</Heading>
                    <Text fontSize="10px" fontWeight="700" color={textColor} mb={4}>{new Date(session.scheduledAt).toLocaleString()}</Text>
                    
                    <Flex gap={2}>
                      {isUnlocked ? (
                        <Button
                          as="a"
                          href={session.meetingLink.startsWith('http') ? session.meetingLink : `https://${session.meetingLink}`}
                          target="_blank"
                          size="xs"
                          bgGradient="linear(to-r, purple.500, blue.500)"
                          color="white"
                          borderRadius="full"
                          px={4}
                          py={3}
                          fontSize="9px"
                          fontWeight="800"
                          _hover={{ bgGradient: "linear(to-r, purple.600, blue.600)", transform: "translateY(-1px)" }}
                          _active={{ bgGradient: "linear(to-r, purple.600, blue.600)" }}
                          transition="all 0.2s"
                        >
                          Join Link
                        </Button>
                      ) : isExpired ? (
                        <Box
                          flex={1}
                          bg={lockedBg}
                          border="1px dashed"
                          borderColor={lockedBorder}
                          borderRadius="xl"
                          py={2}
                          px={3}
                          textAlign="center"
                        >
                          <Text fontSize="9px" fontWeight="800" color={textColor} letterSpacing="0.5px">SESSION ENDED</Text>
                          <Text fontSize="8px" color={textColor} mt={0.5} opacity={0.7}>No longer available</Text>
                        </Box>
                      ) : (
                        <Box
                          flex={1}
                          bg={lockedBg}
                          border="1px dashed"
                          borderColor={lockedBorder}
                          borderRadius="xl"
                          py={2}
                          px={3}
                          textAlign="center"
                        >
                          <Text fontSize="9px" fontWeight="800" color={textColor} letterSpacing="0.5px">🔒 OPENS IN {countdown}</Text>
                          <Text fontSize="8px" color={textColor} mt={0.5} opacity={0.7}>1 min after start</Text>
                        </Box>
                      )}
                      <Menu>
                        <MenuButton
                          as={IconButton}
                          icon={<FaEllipsisV />}
                          size="xs"
                          variant="ghost"
                          colorScheme="gray"
                          aria-label="Options"
                          ml={2}
                          _hover={{ bg: "rgba(255,255,255,0.1)" }}
                        />
                        <MenuList minW="150px" bg={cardBg} borderColor={cardBorder} boxShadow="xl">
                          {!isUnlocked && (
                            <MenuItem onClick={() => handleStartImmediately(session._id)} fontWeight="600" color="green.500" _hover={{ bg: "green.50" }}>
                              🚀 Start Immediately
                            </MenuItem>
                          )}
                          <MenuItem onClick={() => handleEditSession(session)} fontWeight="600" _hover={{ bg: "blue.50", color: "blue.600" }}>
                            ✏️ Edit Session
                          </MenuItem>
                          <MenuItem onClick={() => handleDeleteSession(session._id)} fontWeight="600" color="red.500" _hover={{ bg: "red.50" }}>
                            🗑️ Cancel Session
                          </MenuItem>
                        </MenuList>
                      </Menu>
                    </Flex>
                  </Box>
                );
              })}
            </SimpleGrid>
          ) : (
            <Text color={textColor} fontSize="xs" fontStyle="italic">No live sessions scheduled. Click "Schedule Live Session" above to start one.</Text>
          )}
        </Box>

        {/* Live Session Scheduling Modal */}
        <Modal isOpen={isOpen} onClose={handleCloseModal} size="xl">
          <ModalOverlay />
          <ModalContent borderRadius="3xl" p={2} bg="rgba(255, 255, 255, 0.95)" backdropFilter="blur(20px)">
            <ModalHeader textAlign="center" pt={6}>
              <Heading size="md" bgGradient="linear(to-r, purple.500, blue.500)" bgClip="text">{editSessionId ? "Edit Live Session" : "Schedule Live Session"}</Heading>
            </ModalHeader>
            <ModalCloseButton mt={3} mr={3} />
            <ModalBody>
              <Stack spacing={4}>
                <FormControl isRequired>
                  <FormLabel fontWeight="700" fontSize="xs" color="gray.600">Session Title</FormLabel>
                  <Input 
                    name="title" 
                    placeholder="e.g. Advanced Cybersecurity Audits & Firewalls" 
                    value={sessionForm.title} 
                    onChange={handleSessionChange}
                    borderRadius="xl"
                  />
                </FormControl>
                
                <FormControl isRequired>
                  <FormLabel fontWeight="700" fontSize="xs" color="gray.600">Description</FormLabel>
                  <Textarea 
                    name="description" 
                    placeholder="Describe the main objectives and learning outcomes of this live training..." 
                    value={sessionForm.description} 
                    onChange={handleSessionChange}
                    borderRadius="xl"
                  />
                </FormControl>

                <FormControl isRequired>
                  <FormLabel fontWeight="700" fontSize="xs" color="gray.600">Meeting Link (Zoom / Teams / Meet)</FormLabel>
                  <Input 
                    name="meetingLink" 
                    placeholder="e.g. https://teams.microsoft.com/..." 
                    value={sessionForm.meetingLink} 
                    onChange={handleSessionChange}
                    borderRadius="xl"
                  />
                </FormControl>

                <SimpleGrid columns={2} gap={4}>
                  <FormControl isRequired>
                    <FormLabel fontWeight="700" fontSize="xs" color="gray.600">Date & Time</FormLabel>
                    <Input 
                      type="datetime-local" 
                      name="scheduledAt" 
                      value={sessionForm.scheduledAt} 
                      onChange={handleSessionChange}
                      borderRadius="xl"
                    />
                  </FormControl>

                  <FormControl isRequired>
                    <FormLabel fontWeight="700" fontSize="xs" color="gray.600">Duration (Minutes)</FormLabel>
                    <Input 
                      type="number" 
                      name="duration" 
                      placeholder="60" 
                      value={sessionForm.duration} 
                      onChange={handleSessionChange}
                      borderRadius="xl"
                    />
                  </FormControl>
                </SimpleGrid>

                <FormControl isRequired>
                  <FormLabel fontWeight="700" fontSize="xs" color="gray.600">Target Department Sector Visibility</FormLabel>
                  <Select 
                    name="targetSector" 
                    value={sessionForm.targetSector} 
                    onChange={handleSessionChange}
                    borderRadius="xl"
                  >
                    <option value="Global">Global (All Employees)</option>
                    <option value="IT">IT Sector Only</option>
                    <option value="Finance">Finance Sector Only</option>
                    <option value="Workforce">Workforce Sector Only</option>
                  </Select>
                </FormControl>
              </Stack>
            </ModalBody>
            <ModalFooter gap={3}>
              <Button variant="ghost" onClick={onClose} borderRadius="full" fontSize="xs" fontWeight="800">Cancel</Button>
              <Button colorScheme="blue" onClick={handleCreateSession} borderRadius="full" px={8}>
                {editSessionId ? "Save Changes" : "Schedule"}
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Box>
    </Box>
  );
}

export default TeacherDashboard;
